module.exports = __webpack_public_path__ + "media/images/icon_join-c248ad2c406ab9ce0a329e3c88bab676.svg";